/*@ngInject*/
const UpdateFieldInstanceRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.updateFieldInstance = function (fieldId, instance) {
        let url = '/rest/Field/' + fieldId;

        return this.post(url, instance);
    };
};

angular.module('umFormViewer')
    .service('updateFieldInstanceRepository', UpdateFieldInstanceRepository);
